/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'search-reset': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M959.008 354.933a392.533 392.533 0 00-750.933 101.6H34.133l204.8 204.8 204.8-204.8H274.037c24.63-156.256 160.224-276.128 323.296-276.128 180.491 0 327.328 146.838 327.328 327.328S777.824 835.061 597.333 835.061a327.861 327.861 0 01-207.53-74.186 32.608 32.608 0 00-41.376 50.4 392.64 392.64 0 00610.581-456.342z"/>'
  }
})
